module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"attributes-page\">\n    <h3>Записи справочника</h3>\n    <div class='add-layer-table'>\n        <table>\n            <thead>\n            <tr>\n                <td></td>\n                <td>Ключ</td>\n                <td>Значение</td>\n            </tr>\n            </thead>\n            <tbody name=\"records\">\n            </tbody>\n        </table>\n    </div>\n</div>\n")
  }
  return __output.join("");

}